/**
 * The old public Library links used capitalised `Brief` and `Film` formats on `/library`. Direction
 * AC moved those reference rows to `/cards`; translate only those known links. Bare `/library` and
 * module filters belong to the current Learn page and stay there.
 */
export function legacyLibraryTarget(search: string): string | null {
  const source = new URLSearchParams(search);
  const legacyFormat = source.get('format');
  const format = legacyFormat === 'Brief' ? 'brief' : legacyFormat === 'Film' ? 'film' : null;
  if (!format) return null;

  const target = new URLSearchParams({ format });
  const q = source.get('q');
  const saved = source.get('saved');
  const destination = source.get('track');
  if (q !== null) target.set('q', q);
  if (saved !== null) target.set('saved', saved);
  if (destination === 'Antarctica') target.set('dest', 'antarctica');
  if (destination === 'Arctic') target.set('dest', 'arctic');
  return `/cards?${target.toString()}`;
}
